<template>
    <!-- Hero Sections Here -->
   <section class="banner__breadcumn ralt">

<!--Search Popup-->
<div id="searchPopup" class="search__popup">
   <form action="#" class="popup-content d-flex align-items-center">
      <input type="text" placeholder="Search Here">
      <button id="closeButton">
         <i class="bi bi-x-lg"></i>
      </button>
   </form>
</div>
<!--Search Popup-->

<div class="breadcumnd__wrapper">
   <div class="container">
      <div class="profile__wrapper">
         <div class="row g-4 align-items-center justify-content-between">
            <div class="col-xxl-6 col-xl-6 col-lg-7 col-md-7 col-sm-7">
               <div class="breadcumnd__content">
                  <span class="d41 mb-24">
                     Yangiliklar
                  </span>
               </div>
            </div>
         </div>
      </div>
   </div>
</div>
</section>
<!-- Hero Section End -->

<!-- Blog Categories Here -->
<section class="blog__sections sectionbg pt-60 pb-120">
<div class="container">
   <div class="row g-4">
      <div class="col-xl-8 col-lg-8">
         <div class="balance__transfercard shadow1 p-8 bgwhite mb-24 round16">
            <div class="bt__one mb-20">
               <img src="assets/img/service/ustozlar.jpg" alt="balance" class="round16 w-101">
            </div>
            <div class="blog__content">
               <ul class="blog__addmin flex-wrap mb-24 d-flex align-items-center">
                  <li class="fz-18 ralt fw-400 inter ptext2 d-flex align-items-center gap-2">
                        21.10.2024 
                  </li>
                  <li class="fz-18 ralt fw-400 inter ptext2 d-flex align-items-center gap-2">
                     574
                  </li>            
               </ul>
               <h3 class="title mb-24">
                    21-oktyabr – O‘zbek tili bayrami kuni
               </h3>
               
               <p class="fz-16 fw-400 inter pra">
                Shu kunlarda respublikamiz bo‘ylab o‘zbek tiliga davlat tili maqomi berilganining 35-yilligi joylarda madaniy-ma’rifiy tadbirlar, shuningdek, ona tilimiz jonkuyarlari bo‘lmish olimlar, shoir hamda yozuvchilar bilan uchrashuv va suhbatlar bo‘lib o‘tmoqda.
               </p>
               <p class="fz-16 fw-400 inter pra">
                Bugun shunday uchrashuvlardan biri “O‘zbekiston pochtasi” aksiyadorlik jamiyatida o‘tkazildi.
               </p>
               <p class="fz-16 fw-400 inter pra">
                Unda O‘zbekiston Yozuvchilar uyushmasi a’zosi, shoir, “Shuhrat” medali sohibi Turob Niyoz qatnashib, ishtirokchilarga o‘zbek tilining ahamiyati va jamiyatimizda tutgan o‘rni to‘g‘risida gapirdi:
               </p>
               <br>
               <p class="fz-16 fw-400 inter pra">
                - Hozir mamlakatimizda davlat tili bo‘lmish o‘zbek tiliga juda katta e’tibor berilmoqda. Masalan, 30 dan ortiq oliy ta’lim muassasalarida o‘zbek tili va adabiyoti yo‘nalishida yuqori malakali mutaxassislar tayyorlanmoqda. Bundan tashqari, ayni paytda ona tilimiz dunyo davlatlarining 60 ga yaqin universitet hamda 100 dan ortiq maktablarida o‘rganilmoqda. Shuning o‘ziyoq o‘zbek tilining qadri va obro‘yi kun sayin ko‘tarilib borayotganidan darak beradi. Shundan so‘ng Turob Niyoz ona tilimizga bag‘ishlangan o‘z she’rlaridan o‘qib berdi va qatnashchilarning turli savollariga javob qaytardi.
                </p>
                <br>
                <p class="fz-16 fw-400 inter pra">
                 Uchrashuv qiziqarli va do‘stona ruhda o‘tdi.
                </p>
            </div>
         </div>
         
         <div class="trending__based bgwhite round16 shadow1">
            <h4 class="pb-24 title bborderdash mb-24">
               Izoh qoldiring
            </h4>
            <form action="#0" class="writing__review">
               <div class="wrigt__grp">
                  <label for="name">Ism</label>
                  <input type="text" id="name" placeholder="Ismingizni kiriting">
               </div>
               <div class="wrigt__grp">
                  <label for="email">Email</label>
                  <input type="text" id="email" placeholder="Email manzil kiriting...">
               </div>
               <div class="wrigt__grp">
                  <label for="name">Izoh</label>
                  <textarea class="form-control" placeholder="izoh yozib qoldiring" id="textAreaExample"
                     rows="4"></textarea>
               </div>
               <button class="cmn--btn mt-16">
                  <span>
                     Yuborish
                  </span>
                  <span>
                     <i class="bi bi-arrow-up-right"></i>
                  </span>
               </button>
            </form>
         </div>
      </div>
      <div class="col-xl-4 col-lg-4">
                    <div class="blog__sidebar">
                        <div class="blog__common__item bgwhite round16 mb-24">
                            <h4 class="head fw-600 bborderdash title pb-24 mb-24">
                                Ko‘p ko‘rilgan maqolalar
                            </h4>
                            <ul class="recent__post">
                                <li>
                                    <a href="/yangilik5"
                                        class="recent___item bborderdash mb-24 pb-24 d-flex align-items-center">
                                        <span class="cateicon">
                                            <img src="assets/img/service/ustozlar.jpg" alt="round"
                                                style="width: 100px; height: 90px;">
                                        </span>
                                        <span class="fz-20 post__content fw-600 title inter">
                                            21-oktyabr – O‘zbek tili bayrami kuni
                                            <span class="d-block fz-18 fw-400 base inter">
                                                21.10.2024
                                            </span>
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="/yangilik2"
                                        class="recent___item mb-24 bborderdash pb-24 d-flex align-items-center">
                                        <span class="cateicon">
                                            <video class="round16 w-101" controls style="width: 80px; height: 100px;">
                                                <source src="/assets/img/service/12.MP4" type="video/mp4">
                                                Sizning brauzeringiz video formatni qo'llab-quvvatlamaydi.
                                            </video>
                                        </span>
                                        <span class="fz-20 post__content fw-600 title inter">
                                            18-noyabr Davlat bayrog‘i kuni ...
                                            <span class="d-block fz-18 fw-400 base inter">
                                                18.11.2024
                                            </span>
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="/yangilik4"
                                        class="recent___item mb-24 bborderdash pb-24 d-flex align-items-center">
                                        <span class="cateicon">
                                            <img src="assets/img/service/1e4563610069470abf302b7759b7179d.jpg"
                                                alt="round" style="width: 100px; height: 90px;">
                                        </span>
                                        <span class="fz-20 post__content fw-600 title inter">
                                            “O‘zbekiston pochtasi” AJ aksiyadorlarining ...
                                            <span class="d-block fz-18 fw-400 base inter">
                                                13.11.2024
                                            </span>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="blog__common__item bgwhite round16">
                            <h4 class="head fw-600 bborderdash title pb-24 mb-24">
                                Bizni kuzatib boring
                            </h4>
                            <ul class="social d-flex align-items-center">
                                <li>
                                    <a href="https://www.facebook.com/uzpochta">
                                        <i class="bi bi-facebook"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/uzpost_/">
                                        <i class="bi bi-instagram"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://t.me/uzpostuz">
                                        <i class="bi bi-telegram"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
   </div>
</div>
</section>
<!-- Blog Categories End -->
</template>